module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.openItem(item) : _vm.select(item.id)
        }
      }
    }, [_c('v-list-tile-content', {
      staticStyle: {
        "justify-content": "start"
      }
    }, [_c('v-list-tile-title', [_c('b', [_c('a', {
      attrs: {
        "href": _vm.getItemRef(item),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(item.description) + "\n               ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_vm._v(" " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.isSelectMode()),
        expression: "cxt.isSelectMode()"
      }]
    }, [_c('v-list-tile-action-text', [_vm._v("  " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id + '')),
        expression: "cxt.check(item.id + '')"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id + '')),
        expression: "cxt.uncheck(item.id + '')"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id + '')),
        expression: "cxt.check(item.id + '')"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id + '')),
        expression: "cxt.uncheck(item.id + '')"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235c6402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/PeopleSelectorTab.vue
// module id = 898
// module chunks = 1